// Using this function as a workaround to set data coming from the api in the session
// then reading this value in the loader and returning it rather than making a new GET request
// setting no-bust so the cache buster doesn't remove it immediately and also setting a ttl of 1 minute so it expires quickly after using it
// it will be deleted by the getSessionValue function below anyways, so we don't keep data in the session after using it
export const setSession = (
  session,
  key,
  value,
  ttl = "1 minute",
  opts = {
    meta: ["no-bust"],
    ttl: ttl,
  }
) => {
  session.set(key, value, opts);
};

export const getSessionValue = (session, key) => {
  const value = session.get(key);
  session.delete(key);
  return value;
};
